export default "__VITE_ASSET__Dy6k6JcS__"